<template>
    <div class="row">
        <div class="col-12">
            <div class="d-flex align-items-center justify-content-between mb-4">
                <h4><i class="fas fa-history"></i> Condições Habitacionais</h4>
                <div>
                    <button
                        class="btn active btn-outline-secondary btn-sm"
                        title="Voltar para Identificação da Família e Endereço"
                        @click="$emit('voltar')"
                    >
                        <i class="mdi mdi-arrow-left"></i>Voltar
                    </button>
                </div>
            </div>
        </div>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <div
            class="col-md-6 mb-3"
            v-for="habitacao in habitacoes"
            :key="habitacao.id"
        >
            <div class="card border">
                <div class="card-header bg-gray">
                    <p>
                        Data: <b>{{ habitacao.created_at }}</b>
                    </p>
                    <p>
                        Técnico: <b>{{ habitacao.user_id }}</b>
                    </p>
                </div>
                <div class="card-body">
                    <p>
                        <b
                            >Características do local onde está situado o
                            domicílio
                        </b>
                        {{
                            verificarResposta(
                                habitacao.local,
                                $root.arrays.local
                            )
                        }}
                    </p>
                    <p>
                        <b>Tipo de residência </b>
                        {{
                            verificarResposta(
                                habitacao.tipo_residencia,
                                $root.arrays.tipo_residencia
                            )
                        }}
                    </p>
                    <p>
                        <b>Quantos cômodos tem seu domicílio? </b>
                        {{ habitacao.quant_comodos }}
                    </p>
                    <p>
                        <b>Quantos cômodos tem seu domicílio? </b>
                        {{ habitacao.quant_comodos_dormitorio }}
                    </p>
                    <p>
                        <b
                            >Quanto é nº de pessoas do domicílio dividido pelo
                            nº de dormitórios? :</b
                        >
                        {{ habitacao.numero_pessoas_dormitorio }}
                    </p>
                    <p>
                        <b>Material predominante no piso? </b>
                        {{
                            verificarResposta(
                                habitacao.material_piso,
                                $root.arrays.material_piso
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Material predominante na construção das paredes
                            externas?
                        </b>
                        {{
                            verificarResposta(
                                habitacao.material_paredes,
                                $root.arrays.material_paredes
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Possui água canalizada para, pelo menos, um cômodo?
                        </b>
                        {{ pergunta(habitacao.agua_canalizada) }}
                    </p>
                    <p>
                        <b
                            >Forma de abastecimento de água utilizada no seu
                            domicílio?
                        </b>
                        {{
                            verificarResposta(
                                habitacao.forma_abastecimento_agua,
                                $root.arrays.forma_abastecimento_agua
                            )
                        }}
                    </p>
                    <p>
                        <b>Na propriedade existe banheiro ou sanitário? </b>
                        {{ pergunta(habitacao.banheiro) }}
                    </p>
                    <p>
                        <b
                            >De que forma é feito o escoamento do banheiro ou
                            sanitário?
                        </b>
                        {{
                            verificarResposta(
                                habitacao.forma_escoamento_sanitario,
                                $root.arrays.forma_escoamento_sanitario
                            )
                        }}
                    </p>
                    <p>
                        <b>Forma de coleta do lixo? </b>
                        {{
                            verificarResposta(
                                habitacao.destino_lixo,
                                $root.arrays.destino_lixo
                            )
                        }}
                    </p>
                    <p>
                        <b>Forma de iluminação utilizada no seu domicílio? </b>
                        {{
                            verificarResposta(
                                habitacao.iluminacao,
                                $root.arrays.iluminacao
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Existe calçamento/pavimentação em frente ao seu
                            domicílio?
                        </b>
                        {{
                            verificarResposta(
                                habitacao.calcamento_pavimentacao,
                                $root.arrays.calcamento_pavimentacao
                            )
                        }}
                    </p>
                    <p>
                        <b
                            >Possui acessibilidade para pessoas com dificuldade
                            de locomoção? :</b
                        >
                        {{ pergunta(habitacao.acessibilidade_locomocao) }}
                    </p>
                    <p>
                        <b
                            >Domicílio localizado em área de risco de
                            desabamento ou alagamento? :</b
                        >
                        {{ pergunta(habitacao.area_risco) }}
                    </p>
                    <p>
                        <b
                            >Domicílio localizado em área de difícil acesso
                            geográfico?
                        </b>
                        {{ pergunta(habitacao.area_dificl_acesso) }}
                    </p>
                    <p>
                        <b
                            >Domicílio localizado em área com forte presença de
                            conflito/violência? :</b
                        >
                        {{ pergunta(habitacao.area_conflito_violencia) }}
                    </p>
                    <p>
                        <b
                            >Outras observações referentes ao diagnóstico das
                            condições habitacionais da família :</b
                        >
                        {{ habitacao.observacoes_domicilio }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "Read",
    props: ["familiaId"],
    data() {
        return {
            loading: true,
            habitacoes: {},
        };
    },
    mounted() {
        this.getHabitacao();
    },
    methods: {
        // setTitle(title) {
        // 	return title.replaceAll("_", " ");
        // },
        // setTexto(text) {
        // 	var str = "";
        // 	if (text == true) {
        // 		str = "Sim";
        // 	} else if (text == false) {
        // 		str = "Não";
        // 	} else {
        // 		str = text;
        // 	}
        // 	return str;
        // },
        getHabitacao() {
            axios
                .get(
                    "api/dashboard/familias/historico/habitacao/" +
                        this.familiaId
                )
                .then((response) => {
                    this.habitacoes = response.data.data;
                    this.loading = false;
                })
                .catch(() => {
                    this.$router.push(
                        "/dashboard/familias/edit/" +
                            this.familiaId +
                            "/identificacao"
                    );
                });
        },
        dateConverter(date) {
            if (date) {
                return moment(date).format("DD/MM/YYYY");
            } else {
                return "";
            }
        },
        pergunta(item) {
            var value = item == 1 ? 0 : 1;
            return this.$root.arrays.pergunta[value].value;
        },
        verificarResposta(resposta, array) {
            const result = array.filter((item) => item.id == resposta);
            return result[0] ? result[0].value : "";
        },
    },
};
</script>
